import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import 'antd/dist/reset.css';
import 'virtual:uno.css';

import './i18n';
import { initKeycloak } from './keycloak-client';

const el = document.getElementById('root') as HTMLElement;
const root = createRoot(el);

// Initialize Keycloak before rendering the app
initKeycloak()
  .then(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  })
  .catch((error) => {
    console.error('Failed to initialize Keycloak:', error);
    // Render error state or fallback
    root.render(
      <div>
        <h1>Authentication Error</h1>
        <p>Failed to initialize authentication. Please refresh the page.</p>
      </div>,
    );
  });
